import { useEffect, useRef, useState } from 'react'

import useWindowFocus from 'hooks/use-window-focus'

const DEFAULT_INACTIVE_AFTER_MS = 1000 * 60 // 1min

// tracks window focus and changes to inactive when window is unfocused for specified time.
// immediately changes back to active when focused again
const useActiveWindow = (inactiveAfterMs = DEFAULT_INACTIVE_AFTER_MS) => {
  const windowIsFocused = useWindowFocus()
  const timeoutId = useRef(null)
  const [isActive, setIsActive] = useState(true)

  useEffect(() => {
    const clearCurrentTimeout = () => {
      if (timeoutId.current) clearTimeout(timeoutId.current)
    }

    if (windowIsFocused) {
      clearCurrentTimeout()
      setIsActive(true)
    } else {
      timeoutId.current = setTimeout(() => {
        setIsActive(false)
      }, inactiveAfterMs)
    }

    return () => clearCurrentTimeout()
  }, [windowIsFocused, inactiveAfterMs])

  return isActive
}

export default useActiveWindow
